import { useNavigate, useParams } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import ReferralSourceList from 'components/referralSources/ReferralSourceList';
import CircularProgress from 'components/shared/CircularProgress';
import { adminClientsQueryKeys, adminShowClient } from 'services/api/admin/clients';

// Admin > Clients > (three dot menu) > Referral Sources. The same screen the customer sees, pointed
// at a chosen client, so Olio staff can set a customer's list up during onboarding. Mirrors
// AdminUserPreferences, which does this for notification preferences.
//
// The client is fetched only to title the page — the list itself is addressed by the id in the path.
export default function AdminReferralSources() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data: client, isLoading } = useQuery({
    queryKey: adminClientsQueryKeys.show(id!),
    queryFn: ({ signal }) => adminShowClient(id!, signal),
    enabled: !!id,
  });

  // `!client` as well as `isLoading`, the same gate AdminUserPreferences uses. A client outside
  // Admin::ClientPolicy::Scope — or a mistyped id — 404s both this fetch and the list, and without
  // it the page rendered the "No referral sources yet" empty state with a live Add New button whose
  // POST 404s too, which reads as an empty list rather than as no access.
  if (isLoading || !client) return <CircularProgress />;

  return (
    <ReferralSourceList
      clientId={id}
      isAdmin
      title={`Referral Sources — ${client.name}`}
      onBack={() => navigate('/admin/clients')}
    />
  );
}
